import React from 'react';
import S from './style';

function Badge(properties) {
  return <S.Tag {...properties} />;
}

export default Badge;
